import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';

// A lazy-loaded route chunk can fail to fetch on a transient network blip (or a stale chunk
// hash after a new deploy) — Vite fires this event when that happens. Reload once to recover;
// the sessionStorage guard stops a reload loop if the page is still failing (e.g. genuinely
// offline) rather than retrying forever.
window.addEventListener('vite:preloadError', () => {
  const key = 'pulse:preload-reload-attempted';
  if (!sessionStorage.getItem(key)) {
    sessionStorage.setItem(key, '1');
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element #root not found in index.html');

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
